import type { ProjectsTranslations } from "../../types/projects";

export const projects: ProjectsTranslations = {
  title: "Projektid",
  description:
    "Sirvige projektide kaustastruktuuri, korraldage dokumente ja tehke koost\u00F6\u00F6d oma meeskonnaga.",
  buildingIdRequired: "Hoone ID on n\u00F5utav",
  manageShares: "Halda jagamisi",
  empty: {
    title: "Looge oma esimene projekt",
    description:
      "Projektid hoiavad iga hoone dokumendid korrastatuna omaenda kaustastruktuuris. Looge oma esimene projekt, et alustada dokumentide \u00FCleslaadimist ja jagamist oma meeskonnaga.",
    createButton: "Loo uus projekt",
    organiseTitle: "Korraldage dokumendid projektide kaupa",
    organiseDesc:
      "Koondage dokumendid projektip\u00F5histesse kaustadesse, et hoone k\u00F5ik materjalid p\u00FCsiksid struktureeritud ja h\u00F5lpsasti leitavad.",
    collaborateTitle: "Jagage ja tehke koost\u00F6\u00F6d oma meeskonnaga",
    collaborateDesc:
      "Kutsuge oma meeskond projekti ja hallake jagatud juurdep\u00E4\u00E4su, et \u00F5iged inimesed n\u00E4eksid ja saaksid t\u00F6\u00F6tada \u00F5igete dokumentidega.",
  },
  selector: {
    searchPlaceholder: "Otsi projekte...",
    noProjects: "Projekte ei leitud.",
    newProject: "Uus projekt",
    updatedBy: "Muutis",
    documentsLabel: "dokumenti",
  },
  card: {
    seeAll: "Vaata kõiki",
    showFewer: "Näita vähem",
    documents: "dokumenti",
    members: "liiget",
    issues: "ülesannet",
    actions: "Projekti tegevused",
  },
  projectCount: "{count} projekti",
  chooser: {
    title: "Vali projekt",
    subtitle: "Jätkamiseks vali projekt",
    noAccessTitle: "Sa ei ole selle hoone ühegi projekti liige",
    noAccessBody: "Palu projekti omanikul lisada sind projekti, et selle faile näha.",
  },
  activity: {
    uploadsThisWeek: "{count} üleslaadimist sel nädalal",
    openIssues: "{count} avatud ülesannet",
    lastActivity: "Viimane tegevus {time}",
    noRecentActivity: "Hiljutine tegevus puudub",
    unavailable: "Tegevus pole saadaval",
  },
  create: {
    button: "Loo uus projekt",
    modalTitle: "Uus projekt",
    modalSubtitle: "Üks arendus-, ehitus- või renoveerimisprojekt.",
    modalNameLabel: "Projekti nimi",
    modalNamePlaceholder: "2. korruse kirdetiiva ehitusprojekt",
    modalDescriptionLabel: "Kirjeldus",
    modalDescriptionPlaceholder: "Kirjelda lühidalt projekti",
    modalOptionalLabel: "Valikuline",
    modalGuidance:
      "Ära loo eraldi projekti iga dokumendikomplekti jaoks. Saad jaotada failid kaustadesse projekti sees.",
    modalSubmit: "Loo projekt",
    nameLabel: "Projekti nimi",
    namePlaceholder: "Sisestage projekti nimi",
    descriptionLabel: "Kirjeldus (valikuline)",
    descriptionPlaceholder: "Sisestage projekti kirjeldus",
    creating: "Loomine...",
    success: "Projekt edukalt loodud",
    authRequired: "Projektide loomiseks logige sisse",
    orgRequired: "Valige esmalt organisatsioon",
    nameRequired: "Projekti nimi on n\u00F5utav",
    createdSuccess: "Projekt loodud! Valige nüüd failid üleslaadimiseks.",
    createFailed: "Projekti loomine eba\u00F5nnestus",
  },
  edit: {
    title: "Muuda projekti",
    updating: "Uuendamine...",
    submit: "Uuenda projekt",
    success: "Projekt edukalt uuendatud",
    failed: "Projekti uuendamine ebaõnnestus",
    authRequired: "Projektide uuendamiseks logige sisse",
    orgRequired: "Valige esmalt organisatsioon",
  },
  status: {
    active: "Aktiivne",
    inactive: "Mitteaktiivne",
    all: "Kõik",
    filterLabel: "Projekti staatus",
    markActive: "Märgi aktiivseks",
    markInactive: "Märgi mitteaktiivseks",
    markedActive: "Projekt märgiti aktiivseks",
    markedInactive: "Projekt märgiti mitteaktiivseks",
    changeFailed: "Projekti staatuse muutmine ebaõnnestus. Palun proovi uuesti.",
    noPermission: "Sul pole õigust projekti staatust muuta.",
    noActiveProjects: "Aktiivseid projekte pole.",
    noInactiveProjects: "Mitteaktiivseid projekte pole.",
  },
  archive: {
    deleteAction: "Kustuta projekt",
    deleteTitle: "Kustuta projekt",
    deleteConfirm:
      "Kas olete kindel, et soovite selle projekti kustutada? See eemaldatakse kõigist projektide loeteludest, kuid midagi ei lähe jäädavalt kaotsi — saate selle hiljem arhiivivaatest taastada.",
    deleteSubmit: "Kustuta",
    restore: "Taasta",
    showArchived: "Näita arhiveeritud",
    showActive: "Näita aktiivseid",
    noArchived: "Arhiveeritud projekte pole.",
    restoreTitle: "Taasta projekt",
    restoreConfirm:
      "Kas olete kindel, et soovite selle projekti taastada? See viiakse tagasi aktiivsete projektide hulka.",
    archivedSuccess: "Projekt kustutatud",
    restoredSuccess: "Projekt taastatud",
    archiveFailed: "Projekti kustutamine ebaõnnestus. Palun proovige uuesti.",
    restoreFailed: "Projekti taastamine ebaõnnestus. Palun proovige uuesti.",
    defaultProtected: "Vaikeprojekti ei saa kustutada.",
  },
  selectModal: {
    title: "Vali v\u00F5i loo projekt",
    selectExisting: "Vali olemasolev",
    createNew: "Loo uus",
    loading: "Projektide laadimine...",
    noProjects: "Projekte ei leitud",
    createFirst: "Looge oma esimene projekt alustamiseks",
    selectProject: "Vali projekt",
    chooseProject: "Valige projekt...",
  },
  destination: {
    titleMoveOne: "Liiguta 1 \u00FCksus",
    titleMoveMany: "Liiguta {count} \u00FCksust",
    titleCopyOne: "Kopeeri 1 \u00FCksus",
    titleCopyMany: "Kopeeri {count} \u00FCksust",
    modeLabel: "Mis juhtub originaalidega?",
    moveTitle: "Liiguta",
    moveDescription: "Need eemaldatakse praegusest kaustast.",
    copyTitle: "Kopeeri",
    copyDescription: "Luuakse koopiad; originaalid j\u00E4\u00E4vad oma kohale.",
    destinationHeading: "Sihtkoht",
    projectLabel: "Projekt",
    folderLabel: "Kaust",
    noFolders: "Selles projektis pole veel kaustu.",
    folderLoadError: "Kaustade laadimine ebaõnnestus. Palun proovi uuesti.",
    loadingFolders: "Kaustade laadimine\u2026",
    summaryMove: "Liigutatakse asukohta",
    summaryCopy: "Kopeeritakse asukohta",
    selectFolderHint: "Valige sihtkaust.",
    confirmMove: "Liiguta siia",
    confirmCopy: "Kopeeri siia",
    copying: "Kopeerimine\u2026",
    moving: "Liigutamine\u2026",
    current: "(praegune)",
    currentProjectFallback: "Praegune projekt",
  },
  folder: {
    title: "Projekti kaustad",
    description:
      "Korraldage hoone dokumendid projektip\u00F5hises vaates. Faili kustutamine siit liigutab selle pr\u00FCgikasti ja seda saab taastada 30 p\u00E4eva jooksul.",
    selectOrganization: "Valige organisatsioon kaustade loomiseks",
    folderTargetUnconfirmed: "Kausta avamine on veel pooleli — proovige hetke pärast uuesti.",
    folderLoadFailed: "Projekti kaustade laadimine ebaõnnestus.",
    documentsLoadFailed: "Selle kausta dokumentide laadimine ebaõnnestus.",
    noFolders: "Kaustu pole veel. Looge oma esimene kaust alustamiseks.",
    loadingDocuments: "Dokumentide laadimine\u2026",
    upload: "Lae \u00FCles",
    newFolder: "Uus kaust",
    backToProjectRoot: "Tagasi projekti juurkausta",
    showHiddenFolders: "Näita peidetud kaustu: {folders}",
    addFolder: "Lisa uus kaust",
    createFolderTitle: "Loo uus kaust",
    createSubfolderTitle: "Loo uus alamkaust",
    folderNameLabel: "Kausta nimi",
    folderNamePlaceholder: "Sisesta kausta nimi",
    createFolderSubmit: "Loo kaust",
    documentMoved: "Dokument liigutatud",
    alreadyInFolder: "Juba selles kaustas",
    cannotMoveIntoDescendant: "Kausta ei saa liigutada iseendasse ega oma alamkausta",
    cannotMoveIntoFolder: "Sellesse kausta ei saa faile liigutada",
    moveDocFailed: "Dokumendi liigutamine eba\u00F5nnestus",
    failedOpenContainer: "Konteineri avamine eba\u00F5nnestus",
    permanentDeleteTitle: "Kustuta dokument j\u00E4\u00E4davalt",
    permanentDeleteConfirm:
      'Kas olete kindel, et soovite j\u00E4\u00E4davalt kustutada "{filename}"? Seda toimingut ei saa tagasi v\u00F5tta.',
    permanentDeleteButton: "Kustuta",
    permissionDenied: "\u00D5igused puuduvad",
    permissionDeniedDesc:
      "J\u00E4\u00E4dav kustutamine on saadaval ainult administraatoritele kohandatud projekti kaustades.",
    documentPermanentlyDeleted: "Dokument j\u00E4\u00E4davalt kustutatud",
    documentPermanentlyDeletedDesc: "{filename} on j\u00E4\u00E4davalt kustutatud",
    permanentDeleteFailed: "J\u00E4\u00E4dav kustutamine eba\u00F5nnestus",
    permanentDeleteFailedDesc: "Dokumenti ei \u00F5nnestunud j\u00E4\u00E4davalt kustutada",
    exportPreparing: '"{name}" ekspordi ettevalmistamine...',
    exportNoDocuments: "Selles kaustas pole eksporditavaid dokumente.",
    exportDownloadFailed: "\u00DChtegi faili ei \u00F5nnestunud alla laadida.",
    exportFolderFailed: "Kausta eksportimine eba\u00F5nnestus",
    exportSuccess: '{count} faili eksporditud kaustast "{name}"',
    exportStructureOnly: '"{name}" kaustastruktuur laaditi alla zip-failina',
    itemsMoved: "\u00DCksused edukalt liigutatud",
    itemsPartiallyMoved: "Liigutatud {moved} \u00FCksust, {failed} liigutamine eba\u00F5nnestus",
    itemsCopied: "\u00DCksused edukalt uude projekti kopeeritud",
    operationFailed: "Toiming eba\u00F5nnestus",
    copyToFolderNotSupported:
      "Kausta kopeerimine pole toetatud. Dokumendid saavad olla ainult \u00FChes kaustas korraga.",
    itemsCopiedToProject: "\u00DCksused edukalt uude projekti kopeeritud",
    folderCopyNotSupported:
      "Kaustade kopeerimine pole enam toetatud. Palun kopeerige dokumendid \u00FCksikult.",
    noItemsSelected: "\u00DCksusi pole valitud",
    failedMoveItems: "\u00DCksuste liigutamine eba\u00F5nnestus",
    failedCopyItems: "\u00DCksuste kopeerimine eba\u00F5nnestus",
    failedUpload: "Faili \u00FCleslaadimise t\u00F6\u00F6tlemine eba\u00F5nnestus",
    includeSubfolders: "Kaasa alamkaustad",
  },
  folderPicker: {
    title: "Vali sihtkaust",
    rootFolder: "Juurkaust",
    noFolders: "Kaustu pole saadaval",
    selectFolder: "Vali kaust",
  },
};
